module.exports = __webpack_public_path__ + "static/media/infinity_loader.d964436c.gif";